/** 나이스페이 requestPay `goodsName` 최대 길이 (초과 시 P009 등) */
export const NICE_PAY_GOODS_NAME_MAX_LENGTH = 100;

/** PG 제한에 맞게 상품명을 잘라 낸다. */
export function clampNicePayGoodsName(name: string, maxLen = NICE_PAY_GOODS_NAME_MAX_LENGTH): string {
  const trimmed = name.trim();
  if (trimmed.length <= maxLen) {
    return trimmed;
  }
  return trimmed.slice(0, maxLen);
}
